import { connect } from 'react-redux'
import WorksHeader from './works-header'
import {
  getWorksAssessmentFileTitle,
  getWorksAssessmentFileStudent,
  getWorksAssessmentFileId,
  getWorksCount,
  getWorksList,
  getWorksAssessmentFilePolicy
} from '../../../../../stores/works/works.selectors'
import { openAddWorksDialog } from '../../../../../stores/works/works.actions'

const mapStateToProps = state => {
  const student = getWorksAssessmentFileStudent(state)
  const policy = getWorksAssessmentFilePolicy(state)
  return {
    title: getWorksAssessmentFileTitle(state),
    count: getWorksCount(state),
    id: getWorksAssessmentFileId(state),
    studentId: student && student.account && student.account.id,
    isStudentActive: student && student.active,
    works: getWorksList(state),
    canUpdate: policy && policy.can_update
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onOpenAddWorkDialog: () => {
    return dispatch(
      openAddWorksDialog(
        stateProps.id,
        stateProps.workIds,
        stateProps.studentId
      )
    )
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(WorksHeader)
